module.exports = __webpack_public_path__ + "static/img/Picture4.6f0ffae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191017/Picture4.jpg
// module id = 8y/O
// module chunks = 1